import { baseApiAuthenticated } from '@/api/v2/index';
import { urlBuilder } from '@/api/utils';
import { convertKeycardToFrontend, Keycard } from '@/models/keycard';
import { BackendType } from '@/models/general';

const baseUrl = urlBuilder('order', 'keycards');

type GetKeycardsResponse = {
    keycards: Keycard<BackendType>[];
};

export const keycardsApi = baseApiAuthenticated
    .enhanceEndpoints({ addTagTypes: ['KEYCARDS'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getKeycards: builder.query<Keycard[], { customerId: string }>({
                query: ({ customerId }) => `${baseUrl}?userId=${customerId}`,

                transformResponse: (response: GetKeycardsResponse) => {
                    return response.keycards.map(convertKeycardToFrontend);
                },

                providesTags: ['KEYCARDS'],
            }),

            postResend: builder.mutation<
                void,
                { keycardId: string; reason: string }
            >({
                query: ({ keycardId, reason }) => ({
                    url: `${baseUrl}/${keycardId}/resend`,
                    method: 'POST',
                    body: { reason, keycardId },
                }),
                invalidatesTags: ['KEYCARDS'],
            }),
        }),
    });

export const { useGetKeycardsQuery, usePostResendMutation } = keycardsApi;
